module.exports = __webpack_public_path__ + "static/media/manu-7.66b4bbc7.png";